import { render, staticRenderFns } from "./DashboardErlebenIcon.vue?vue&type=template&id=d849fbf8&scoped=true&"
var script = {}
import style0 from "./DashboardErlebenIcon.vue?vue&type=style&index=0&id=d849fbf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d849fbf8",
  null
  
)

export default component.exports